// ? 全局默认配置项
export const CDN_URL = "https://static.zhihaoscm.cn/";
export const OSS_URL = "https://zhihaoscm-public.oss-cn-hangzhou.aliyuncs.com";

// 路由白名单地址（本地存在的路由 staticRouter.ts 中）
export const ROUTER_WHITE_LIST: string[] = ["/500", "/403"];

// 高德地图 js api key
export const AMAP_MAP_JS_KEY: string = "fa6124a9dc6b90b47e10e0606c340538";

// 高德地图 web云服务 key
export const AMAP_MAP_WEB_KEY: string = "2c93a1b3e2cb4e43e173c50caa49792d";

// 日期时间选择器格式化
export const DATETIME_PICKER_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_PICKER_FORMAT = "YYYY-MM-DD";
export const TIME_PICKER_FORMAT = "HH:mm:ss";

// 日志时间戳格式化
export const LOG_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const LOG_DATE_FORMAT_BEGIN = "YYYY-MM-DD 00:00:00";
export const LOG_DATE_FORMAT_START = "YYYY-MM-DDT00:00:00";
export const LOG_DATE_FORMAT_END = "YYYY-MM-DDT23:59:59";
// 海康摄像头时间戳格式化
export const HIA_DATE_FORMAT = "YYYYMMDDHHmmss";

// 日期格式化
export const DATE_FORMAT_YEAR_MONTH_CN = "YY年MM月";
export const DATE_SHORT_FORMAT_YEAR_MONTH = "YY/MM";
export const DATE_FORMAT_MONTH_DAY = "MM/DD";

// 新增、修改弹框宽度
export const DEFAULT_DIALOG_WIDTH = "842px";
export const W900_DIALOG_WIDTH = "900px";
export const VW75_DIALOG_WIDTH = "75%";

// 上传导入Excel文件格式
export const UploadExcelFileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

// 指数管理批量上传模板
export const ProductTypeIndexFileName =
    CDN_URL +
    "template/%E6%8C%87%E6%95%B0%E7%AE%A1%E7%90%86%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx";

// 设备管理批量上传模板
export const DeviceTypeIndexFileName = CDN_URL + "template/%E8%AE%BE%E5%A4%87%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx";
// 运价指数批量上传模板
export const FreightIndexFileName =
    CDN_URL + "template/%E8%BF%90%E4%BB%B7%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E7%89%88.xlsx";

// 选项卡最大数量
export const MAX_TAG_NUMBER = 10;

// 数据缺省值
export const DEFAULT_VALUE = "--";

// 默认头像
export const DEFAULT_AVATAR = CDN_URL + "customer-admin/avatar.svg";

export const VideoPlayerUrl = `${import.meta.env.VITE_VIDEO_PLAYER_URL}?{dateRange}token={token}&deviceSerial={deviceSerial}&mode={mode}&origin={origin}`;

// 授权委托书下载模板
export const PowerAttorneyFileName =
    CDN_URL + "template/%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6%E6%A8%A1%E6%9D%BF.docx";
